// import { useState, useEffect, useRef } from "react";

// // ─── CSS ──────────────────────────────────────────────────────────────────────
// const CSS = `
//   @import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Rajdhani:wght@300;400;600;700&display=swap');

//   /* ── Splash overlay wrapper ── */
//   .hlc-splash-overlay {
//     position: fixed;
//     inset: 0;
//     z-index: 9999;
//     pointer-events: none; /* let home underneath be interactive after tear */
//   }

//   /* ── Two tear panels ── */
//   .hlc-tear-left,
//   .hlc-tear-right {
//     position: absolute;
//     top: 0;
//     bottom: 0;
//     overflow: hidden;
//     pointer-events: all;
//     will-change: transform;
//   }

//   .hlc-tear-left {
//     left: 0;
//     /* torn right edge via clip-path: jagged vertical line */
//     clip-path: polygon(
//       0% 0%,
//       calc(50% + 18px) 0%,
//       calc(50% + 8px)  4%,
//       calc(50% + 22px) 8%,
//       calc(50% + 4px)  13%,
//       calc(50% + 20px) 17%,
//       calc(50% + 6px)  22%,
//       calc(50% + 24px) 27%,
//       calc(50% + 2px)  31%,
//       calc(50% + 18px) 36%,
//       calc(50% + 8px)  41%,
//       calc(50% + 22px) 46%,
//       calc(50% + 5px)  50%,
//       calc(50% + 21px) 55%,
//       calc(50% + 3px)  60%,
//       calc(50% + 19px) 65%,
//       calc(50% + 9px)  70%,
//       calc(50% + 23px) 75%,
//       calc(50% + 1px)  80%,
//       calc(50% + 17px) 85%,
//       calc(50% + 7px)  90%,
//       calc(50% + 21px) 95%,
//       calc(50% + 10px) 100%,
//       0% 100%
//     );
//     width: 100%;
//   }

//   .hlc-tear-right {
//     right: 0;
//     /* torn left edge — mirror of above */
//     clip-path: polygon(
//       calc(50% - 10px) 100%,
//       calc(50% - 21px) 95%,
//       calc(50% - 7px)  90%,
//       calc(50% - 17px) 85%,
//       calc(50% - 1px)  80%,
//       calc(50% - 23px) 75%,
//       calc(50% - 9px)  70%,
//       calc(50% - 19px) 65%,
//       calc(50% - 3px)  60%,
//       calc(50% - 21px) 55%,
//       calc(50% - 5px)  50%,
//       calc(50% - 22px) 46%,
//       calc(50% - 8px)  41%,
//       calc(50% - 18px) 36%,
//       calc(50% - 2px)  31%,
//       calc(50% - 24px) 27%,
//       calc(50% - 6px)  22%,
//       calc(50% - 20px) 17%,
//       calc(50% - 4px)  13%,
//       calc(50% - 22px) 8%,
//       calc(50% - 8px)  4%,
//       calc(50% - 18px) 0%,
//       100% 0%,
//       100% 100%
//     );
//     width: 100%;
//   }

//   /* Tear-open animation */
//   .hlc-tear-left.tearing {
//     animation: hlc-tear-left 0.72s cubic-bezier(0.7, 0, 0.95, 1) forwards;
//   }
//   .hlc-tear-right.tearing {
//     animation: hlc-tear-right 0.72s cubic-bezier(0.7, 0, 0.95, 1) forwards;
//   }

//   @keyframes hlc-tear-left {
//     0%   { transform: translateX(0); }
//     100% { transform: translateX(-105%); }
//   }
//   @keyframes hlc-tear-right {
//     0%   { transform: translateX(0); }
//     100% { transform: translateX(105%); }
//   }

//   /* ── inner splash content (lives inside each panel) ── */
//   .hlc-tear-inner {
//     position: absolute;
//     inset: 0;
//     background: #050008;
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     overflow: hidden;
//   }

//   /* The actual center content is only rendered inside the LEFT panel;
//      the right panel shows the mirrored background so they look seamless */
//   .hlc-tear-right .hlc-tear-inner {
//     /* mirror the left so the bulb looks centered across both halves */
//     flex-direction: row-reverse;
//   }

//   /* ── star field ── */
//   .hlc-stars {
//     position: absolute;
//     inset: 0;
//     pointer-events: none;
//   }
//   .hlc-star {
//     position: absolute;
//     border-radius: 50%;
//     animation: hlc-twinkle var(--dur) ease-in-out infinite alternate;
//     background: #fff;
//     opacity: var(--op);
//   }
//   @keyframes hlc-twinkle {
//     from { opacity: var(--op); transform: scale(1); }
//     to   { opacity: calc(var(--op) * 0.2); transform: scale(0.5); }
//   }

//   /* ── ambient rings ── */
//   .hlc-ring {
//     position: absolute;
//     border-radius: 50%;
//     border: 1px solid;
//     pointer-events: none;
//     animation: hlc-ring-pulse 3s ease-in-out infinite;
//     opacity: 0;
//   }
//   @keyframes hlc-ring-pulse {
//     0%   { transform: scale(0.8); opacity: 0; }
//     50%  { opacity: 0.15; }
//     100% { transform: scale(1.6); opacity: 0; }
//   }

//   /* ── bulb wrapper ── */
//   .hlc-bulb-stage {
//     position: absolute;
//     left: 50%;
//     top: 50%;
//     transform: translate(-50%, -50%);
//     display: flex;
//     flex-direction: column;
//     align-items: center;
//     justify-content: center;
//     z-index: 10;
//   }

//   .hlc-bulb-drop {
//     animation: hlc-drop 0.9s cubic-bezier(0.22, 1.6, 0.5, 1) forwards;
//   }
//   @keyframes hlc-drop {
//     from { transform: translateY(-120vh) rotate(-8deg); opacity: 0; }
//     to   { transform: translateY(0) rotate(0deg); opacity: 1; }
//   }

//   .hlc-bulb-sway {
//     animation: hlc-sway 0.6s ease-in-out forwards;
//   }
//   @keyframes hlc-sway {
//     0%   { transform: rotate(0deg); }
//     25%  { transform: rotate(4deg); }
//     60%  { transform: rotate(-2deg); }
//     100% { transform: rotate(0deg); }
//   }

//   .hlc-bulb-shatter {
//     animation: hlc-shatter 0.5s cubic-bezier(0.55, 0, 1, 0.45) forwards;
//   }
//   @keyframes hlc-shatter {
//     0%   { transform: scale(1); opacity: 1; filter: brightness(1); }
//     30%  { transform: scale(1.15); filter: brightness(8) saturate(0); }
//     60%  { transform: scale(0.9) rotate(5deg); opacity: 0.6; }
//     100% { transform: scale(3) rotate(15deg); opacity: 0; filter: brightness(3); }
//   }

//   /* ── glow halo ── */
//   .hlc-halo {
//     position: absolute;
//     border-radius: 50%;
//     pointer-events: none;
//     transition: all 0.25s ease;
//     background: radial-gradient(circle, #ff00cc55 0%, #9900cc22 50%, transparent 75%);
//     left: 50%;
//     top: 50%;
//     transform: translate(-50%, -50%) scale(var(--halo-scale, 0.3));
//   }

//   /* ── ray ── */
//   .hlc-ray {
//     position: absolute;
//     height: 2px;
//     transform-origin: 0 50%;
//     background: linear-gradient(to right, #ff80ff99, transparent);
//     border-radius: 2px;
//     animation: hlc-ray-pulse 1.2s ease-in-out infinite alternate;
//   }
//   @keyframes hlc-ray-pulse {
//     from { opacity: 0.3; transform-origin: 0 50%; transform: scaleX(0.7) rotate(var(--ray-angle)); }
//     to   { opacity: 0.9; transform-origin: 0 50%; transform: scaleX(1.1) rotate(var(--ray-angle)); }
//   }

//   /* ── progress bar ── */
//   .hlc-progress {
//     position: absolute;
//     bottom: 40px;
//     left: 50%;
//     transform: translateX(-50%);
//     width: 200px;
//     height: 2px;
//     background: #ffffff18;
//     border-radius: 2px;
//     overflow: hidden;
//     opacity: 0;
//     transition: opacity 0.4s;
//     z-index: 20;
//   }
//   .hlc-progress.visible { opacity: 1; }
//   .hlc-progress-fill {
//     height: 100%;
//     background: linear-gradient(to right, #c0007a, #ff80ff);
//     border-radius: 2px;
//     transition: width 0.1s linear;
//     box-shadow: 0 0 8px #ff00cc;
//   }

//   /* ── crack canvas ── */
//   .hlc-crack-canvas {
//     position: absolute;
//     inset: 0;
//     pointer-events: none;
//     z-index: 20;
//   }

//   /* ── flash ── */
//   .hlc-flash {
//     position: absolute;
//     inset: 0;
//     background: #fff;
//     pointer-events: none;
//     z-index: 30;
//   }

//   /* ── Home content reveal ── */
//   .hlc-home-reveal {
//     position: fixed;
//     inset: 0;
//     z-index: 9998;
//     transform: scale(0.94);
//     opacity: 0;
//     transition: none;
//   }
//   .hlc-home-reveal.bouncing {
//     animation: hlc-home-bounce 0.65s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
//   }
//   @keyframes hlc-home-bounce {
//     0%   { transform: scale(0.92); opacity: 0.3; }
//     60%  { transform: scale(1.025); opacity: 1; }
//     80%  { transform: scale(0.985); }
//     100% { transform: scale(1); opacity: 1; }
//   }
// `;

// // ─── Bulb SVG ─────────────────────────────────────────────────────────────────
// function BulbSVG({ isOn, flicker }) {
//   const glassGrad = isOn ? "url(#gOn)" : "url(#gOff)";
//   const filamentOpacity = isOn ? 1 : 0.35;
//   const glowOpacity = isOn ? (flicker ? 0.4 : 0.9) : 0;
//   const strokeColor = isOn ? "#ff80ff" : "#3a1040";
//   return (
//     <svg width="200" height="260" viewBox="0 0 200 260" style={{ overflow: "visible" }}>
//       <defs>
//         <radialGradient id="gOn" cx="40%" cy="32%" r="62%">
//           <stop offset="0%" stopColor="#fff5ff" stopOpacity="1" />
//           <stop offset="35%" stopColor="#ee55dd" stopOpacity="0.75" />
//           <stop offset="100%" stopColor="#6a006a" stopOpacity="0.95" />
//         </radialGradient>
//         <radialGradient id="gOff" cx="40%" cy="32%" r="62%">
//           <stop offset="0%" stopColor="#251030" stopOpacity="1" />
//           <stop offset="55%" stopColor="#160820" stopOpacity="0.95" />
//           <stop offset="100%" stopColor="#0d0010" stopOpacity="1" />
//         </radialGradient>
//         <radialGradient id="gInner" cx="50%" cy="50%" r="50%">
//           <stop offset="0%" stopColor="#ffffff" stopOpacity="1" />
//           <stop offset="30%" stopColor="#ffccff" stopOpacity="0.85" />
//           <stop offset="100%" stopColor="#ff00cc" stopOpacity="0" />
//         </radialGradient>
//         <radialGradient id="gShimmer" cx="28%" cy="26%" r="32%">
//           <stop offset="0%" stopColor="#ffffff" stopOpacity="0.8" />
//           <stop offset="100%" stopColor="#ffffff" stopOpacity="0" />
//         </radialGradient>
//         <filter id="fGlow">
//           <feGaussianBlur in="SourceGraphic" stdDeviation="5" result="b" />
//           <feMerge><feMergeNode in="b" /><feMergeNode in="SourceGraphic" /></feMerge>
//         </filter>
//         <clipPath id="cBulb">
//           <path d="M100 18 C58 18 26 55 26 98 C26 130 44 157 70 173 L70 200 C70 205 74 209 79 209 L121 209 C126 209 130 205 130 200 L130 173 C156 157 174 130 174 98 C174 55 142 18 100 18 Z" />
//         </clipPath>
//       </defs>
//       <ellipse cx="100" cy="105" rx="66" ry="66"
//         fill="url(#gInner)" opacity={glowOpacity}
//         clipPath="url(#cBulb)"
//         style={{ filter: "blur(8px)", transition: "opacity 0.15s" }} />
//       <path
//         d="M100 18 C58 18 26 55 26 98 C26 130 44 157 70 173 L70 200 C70 205 74 209 79 209 L121 209 C126 209 130 205 130 200 L130 173 C156 157 174 130 174 98 C174 55 142 18 100 18 Z"
//         fill={glassGrad} stroke={strokeColor} strokeWidth="1.5"
//         style={{ transition: "fill 0.12s, stroke 0.12s" }} />
//       <g opacity={filamentOpacity} style={{ transition: "opacity 0.15s" }}>
//         <line x1="100" y1="158" x2="100" y2="138" stroke={isOn ? "#ffccff" : "#aa88aa"} strokeWidth="1.5" />
//         <polyline points="100,138 86,123 112,108 86,93 112,78 100,66"
//           fill="none" stroke={isOn ? "#ffccff" : "#aa88aa"}
//           strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"
//           filter={isOn ? "url(#fGlow)" : "none"} />
//         <line x1="100" y1="158" x2="100" y2="168" stroke={isOn ? "#ffccff" : "#aa88aa"} strokeWidth="1.5" />
//         <line x1="87" y1="122" x2="78" y2="152" stroke="#aa55aa" strokeWidth="0.8" opacity="0.55" />
//         <line x1="113" y1="107" x2="122" y2="152" stroke="#aa55aa" strokeWidth="0.8" opacity="0.55" />
//         <line x1="87" y1="92" x2="78" y2="152" stroke="#aa55aa" strokeWidth="0.8" opacity="0.55" />
//         <line x1="113" y1="78" x2="122" y2="152" stroke="#aa55aa" strokeWidth="0.8" opacity="0.55" />
//       </g>
//       <ellipse cx="78" cy="62" rx="26" ry="18" fill="url(#gShimmer)" opacity="0.65" />
//       <rect x="72" y="208" width="56" height="11" rx="2" fill="#1e0828" stroke="#3a1045" strokeWidth="0.8" />
//       <rect x="74" y="219" width="52" height="7" rx="1" fill="#2a0a38" stroke="#4a1458" strokeWidth="0.7" />
//       <rect x="76" y="226" width="48" height="7" rx="1" fill="#380a4a" stroke="#581868" strokeWidth="0.7" />
//       <rect x="78" y="233" width="44" height="6" rx="1" fill="#2e003a" stroke="#4e0e58" strokeWidth="0.7" />
//       {[221, 225, 229, 234, 238].map((y, i) => (
//         <line key={i} x1={74 + i} y1={y} x2={126 - i} y2={y} stroke="#6a2078" strokeWidth="0.5" opacity="0.45" />
//       ))}
//       <ellipse cx="100" cy="240" rx="20" ry="4.5" fill="#c0007a" opacity="0.9" />
//       <ellipse cx="100" cy="240" rx="20" ry="4.5" fill="none" stroke="#ff40aa" strokeWidth="0.8" opacity="0.5" />
//     </svg>
//   );
// }

// // ─── Stars ────────────────────────────────────────────────────────────────────
// function useParticles(count = 70) {
//   return useRef(
//     Array.from({ length: count }, () => ({
//       x: Math.random() * 100,
//       y: Math.random() * 100,
//       r: Math.random() * 1.4 + 0.3,
//       dur: (Math.random() * 3 + 2).toFixed(1),
//       op: (Math.random() * 0.35 + 0.08).toFixed(2),
//       color: Math.random() > 0.5 ? "#c000aa" : "#ff80ff",
//     }))
//   ).current;
// }

// // ─── Crack Canvas ─────────────────────────────────────────────────────────────
// function CrackCanvas({ progress }) {
//   const ref = useRef(null);
//   useEffect(() => {
//     const canvas = ref.current;
//     if (!canvas) return;
//     const w = canvas.offsetWidth || window.innerWidth;
//     const h = canvas.offsetHeight || window.innerHeight;
//     canvas.width = w;
//     canvas.height = h;
//     const ctx = canvas.getContext("2d");
//     ctx.clearRect(0, 0, w, h);
//     if (progress <= 0) return;
//     const cx = w / 2, cy = h / 2 - 20;
//     const cracks = [
//       [[cx, cy], [cx - 90, cy - 130], [cx - 160, cy - 220]],
//       [[cx, cy], [cx + 100, cy - 110], [cx + 180, cy - 200]],
//       [[cx, cy], [cx - 70, cy + 90], [cx - 120, cy + 220]],
//       [[cx, cy], [cx + 80, cy + 80], [cx + 150, cy + 230]],
//       [[cx, cy], [cx - 160, cy + 25], [cx - 240, cy + 55]],
//       [[cx, cy], [cx + 170, cy + 15], [cx + 250, cy + 45]],
//       [[cx, cy], [cx - 15, cy - 170], [cx - 25, cy - 300]],
//       [[cx, cy], [cx + 20, cy + 170], [cx + 40, cy + 330]],
//     ];
//     cracks.forEach((crack, ci) => {
//       const delay = (ci / cracks.length) * 0.25;
//       const p = Math.max(0, Math.min(1, (progress - delay) / (1 - delay)));
//       if (p <= 0) return;
//       ctx.beginPath();
//       ctx.moveTo(crack[0][0], crack[0][1]);
//       for (let i = 1; i < crack.length; i++) {
//         const [px, py] = crack[i - 1];
//         const [nx, ny] = crack[i];
//         ctx.lineTo(px + (nx - px) * p, py + (ny - py) * p);
//       }
//       ctx.strokeStyle = `rgba(255,180,255,${Math.min(1, p * 2)})`;
//       ctx.lineWidth = 1.5;
//       ctx.shadowBlur = 10;
//       ctx.shadowColor = "#ff00cc";
//       ctx.stroke();
//       ctx.shadowBlur = 0;
//     });
//   }, [progress]);

//   return <canvas ref={ref} className="hlc-crack-canvas" style={{ width: "100%", height: "100%" }} />;
// }

// // ─── Rays ─────────────────────────────────────────────────────────────────────
// function Rays({ visible }) {
//   if (!visible) return null;
//   const rayDefs = [
//     { angle: -90, len: 90 }, { angle: -60, len: 70 }, { angle: -120, len: 70 },
//     { angle: -30, len: 55 }, { angle: -150, len: 55 },
//     { angle: 0, len: 50 },   { angle: 180, len: 50 },
//     { angle: 45, len: 40 },  { angle: 135, len: 40 },
//   ];
//   return (
//     <>
//       {rayDefs.map(({ angle, len }, i) => (
//         <div
//           key={i}
//           className="hlc-ray"
//           style={{
//             position: "absolute",
//             top: "50%",
//             left: "50%",
//             width: `${len}px`,
//             transformOrigin: "0 50%",
//             transform: `rotate(${angle}deg)`,
//             marginTop: "-80px",
//             animationDelay: `${i * 0.08}s`,
//           }}
//         />
//       ))}
//     </>
//   );
// }

// // ─── Splash Panel Content (shared between left & right halves) ────────────────
// function SplashInner({ particles, isOn, flicker, phase, haloOp, haloScale, crackProg, flashOp, showProgress, progress }) {
//   return (
//     <div className="hlc-tear-inner">
//       {/* Stars */}
//       <div className="hlc-stars">
//         {particles.map((p, i) => (
//           <div
//             key={i}
//             className="hlc-star"
//             style={{
//               left: `${p.x}%`,
//               top: `${p.y}%`,
//               width: `${p.r * 2}px`,
//               height: `${p.r * 2}px`,
//               "--dur": `${p.dur}s`,
//               "--op": p.op,
//               animationDelay: `${(i * 0.07) % 3}s`,
//               background: p.color,
//             }}
//           />
//         ))}
//       </div>

//       {/* Ambient rings */}
//       {[180, 280, 380].map((size, i) => (
//         <div
//           key={i}
//           className="hlc-ring"
//           style={{
//             width: size,
//             height: size,
//             borderColor: "#c0007a",
//             animationDelay: `${i * 1}s`,
//             animationDuration: `${3 + i * 0.5}s`,
//             opacity: isOn ? undefined : 0,
//             position: "absolute",
//             left: "50%",
//             top: "50%",
//             transform: "translate(-50%,-50%)",
//           }}
//         />
//       ))}

//       {/* Halo */}
//       <div
//         className="hlc-halo"
//         style={{
//           width: 300,
//           height: 300,
//           opacity: haloOp,
//           "--halo-scale": haloScale,
//         }}
//       />

//       {/* Crack */}
//       <CrackCanvas progress={crackProg} />

//       {/* Flash */}
//       <div className="hlc-flash" style={{ opacity: flashOp }} />

//       {/* Bulb */}
//       <div className="hlc-bulb-stage">
//         <div style={{ position: "relative", width: 0, height: 0 }}>
//           <Rays visible={isOn && phase !== "shatter"} />
//         </div>
//         <div
//           className={
//             phase === "drop" ? "hlc-bulb-drop"
//             : phase === "sway" ? "hlc-bulb-sway"
//             : phase === "shatter" ? "hlc-bulb-shatter"
//             : ""
//           }
//           style={{ opacity: phase === "drop" ? 0 : 1 }}
//         >
//           <BulbSVG isOn={isOn} flicker={flicker} />
//         </div>
//       </div>

//       {/* Progress */}
//       <div className={`hlc-progress${showProgress ? " visible" : ""}`}>
//         <div className="hlc-progress-fill" style={{ width: `${progress}%` }} />
//       </div>
//     </div>
//   );
// }

// // ─── Main Component ───────────────────────────────────────────────────────────
// export default function HLCSplashScreen({ children, onComplete }) {
//   const [phase, setPhase] = useState("drop");
//   const [isOn, setIsOn] = useState(false);
//   const [flicker, setFlicker] = useState(false);
//   const [showProgress, setShowProgress] = useState(false);
//   const [progress, setProgress] = useState(0);
//   const [crackProg, setCrackProg] = useState(0);
//   const [flashOp, setFlashOp] = useState(0);
//   const [haloScale, setHaloScale] = useState(0.3);
//   const [haloOp, setHaloOp] = useState(0);
//   const [tearing, setTearing] = useState(false);
//   const [bouncing, setBouncing] = useState(false);
//   const [done, setDone] = useState(false);

//   const particles = useParticles(80);

//   useEffect(() => {
//     const timers = [];
//     const t = (fn, ms) => { const id = setTimeout(fn, ms); timers.push(id); return id; };

//     t(() => setPhase("sway"), 900);
//     t(() => setPhase("idle"), 1500);

//     // Blink sequence
//     const blinkSeq = [
//       [2200, true], [2420, false], [2600, true], [2720, false],
//       [2850, true], [2930, false], [3020, true], [3080, false],
//       [3160, true], [3200, false], [3260, true],
//     ];
//     blinkSeq.forEach(([ms, on]) => {
//       t(() => {
//         setIsOn(on);
//         setHaloOp(on ? 0.85 : 0);
//         setHaloScale(on ? 2.2 : 0.4);
//         setFlicker(!on);
//       }, ms);
//     });

//     t(() => { setIsOn(true); setFlicker(false); setHaloOp(1); setHaloScale(2.4); }, 3400);
//     t(() => { setShowProgress(true); }, 3700);

//     // Progress bar
//     t(() => {
//       let p = 0;
//       const interval = setInterval(() => {
//         p += 2;
//         setProgress(p);
//         if (p >= 100) clearInterval(interval);
//       }, 40);
//       timers.push(interval);
//     }, 3700);

//     // Flash before crack
//     t(() => {
//       setFlashOp(1);
//       setTimeout(() => setFlashOp(0), 80);
//       setTimeout(() => setFlashOp(0.7), 160);
//       setTimeout(() => setFlashOp(0), 240);
//     }, 5900);

//     // Crack
//     t(() => {
//       setPhase("crack");
//       let cp = 0;
//       const ci = setInterval(() => {
//         cp += 0.025;
//         setCrackProg(Math.min(1, cp));
//         if (cp >= 1) clearInterval(ci);
//       }, 30);
//       timers.push(ci);
//     }, 6050);

//     t(() => { setPhase("shatter"); setIsOn(false); setHaloOp(0); }, 6400);

//     // ── PAGE TEAR ────────────────────────────────────────────────────────────
//     // Start bouncing home content slightly before the tear so it peeks through
//     t(() => { setBouncing(true); }, 6750);
//     // Trigger the tear animation
//     t(() => { setTearing(true); }, 6800);
//     // After tear animation completes, unmount splash entirely
//     t(() => {
//       setDone(true);
//       if (onComplete) onComplete();
//     }, 7600);

//     return () => timers.forEach(clearTimeout);
//   }, []);

//   const sharedProps = { particles, isOn, flicker, phase, haloOp, haloScale, crackProg, flashOp, showProgress, progress };

//   return (
//     <>
//       <style>{CSS}</style>

//       {/* ── Home content sits beneath splash, gets bounce-revealed ── */}
//       {!done && (
//         <div className={`hlc-home-reveal${bouncing ? " bouncing" : ""}`}>
//           {children}
//         </div>
//       )}

//       {/* ── Fully done: render children normally ── */}
//       {done && children}

//       {/* ── Splash overlay with two tear panels ── */}
//       {!done && (
//         <div className="hlc-splash-overlay">
//           <div className={`hlc-tear-left${tearing ? " tearing" : ""}`}>
//             <SplashInner {...sharedProps} />
//           </div>
//           <div className={`hlc-tear-right${tearing ? " tearing" : ""}`}>
//             <SplashInner {...sharedProps} />
//           </div>
//         </div>
//       )}
//     </>
//   );
// }


import { useState, useEffect, useRef } from "react";

// ─── CSS ──────────────────────────────────────────────────────────────────────
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Rajdhani:wght@300;400;600;700&display=swap');

  .hlc-splash-overlay {
    position: fixed;
    inset: 0;
    z-index: 9999;
    pointer-events: none;
    perspective: 1200px;
  }

  /* ── Two tear panels ── */
  .hlc-tear-left,
  .hlc-tear-right {
    position: absolute;
    top: 0; bottom: 0;
    overflow: hidden;
    pointer-events: all;
    will-change: transform;
    backface-visibility: hidden;
    transform-style: preserve-3d;
  }

  .hlc-tear-left {
    left: 0; width: 100%;
    clip-path: polygon(
      0% 0%,
      calc(50% + 22px)  0%,
      calc(50% +  4px)  3.2%,
      calc(50% + 30px)  6.5%,
      calc(50% +  2px)  9.8%,
      calc(50% + 28px) 13.1%,
      calc(50% +  8px) 16.4%,
      calc(50% + 32px) 19.7%,
      calc(50% +  0px) 22.9%,
      calc(50% + 26px) 26.2%,
      calc(50% +  6px) 29.5%,
      calc(50% + 30px) 32.8%,
      calc(50% +  3px) 36.0%,
      calc(50% + 24px) 39.3%,
      calc(50% +  9px) 42.6%,
      calc(50% + 33px) 45.9%,
      calc(50% +  1px) 49.2%,
      calc(50% + 27px) 52.5%,
      calc(50% +  7px) 55.7%,
      calc(50% + 31px) 59.0%,
      calc(50% +  4px) 62.3%,
      calc(50% + 25px) 65.6%,
      calc(50% + 10px) 68.9%,
      calc(50% + 29px) 72.1%,
      calc(50% +  2px) 75.4%,
      calc(50% + 22px) 78.7%,
      calc(50% +  5px) 82.0%,
      calc(50% + 26px) 85.2%,
      calc(50% +  8px) 88.5%,
      calc(50% + 28px) 91.8%,
      calc(50% +  3px) 95.1%,
      calc(50% + 20px) 98.4%,
      calc(50% + 12px) 100%,
      0% 100%
    );
  }

  .hlc-tear-right {
    right: 0; width: 100%;
    clip-path: polygon(
      calc(50% - 12px) 100%,
      calc(50% - 20px) 98.4%,
      calc(50% -  3px) 95.1%,
      calc(50% - 28px) 91.8%,
      calc(50% -  8px) 88.5%,
      calc(50% - 26px) 85.2%,
      calc(50% -  5px) 82.0%,
      calc(50% - 22px) 78.7%,
      calc(50% -  2px) 75.4%,
      calc(50% - 29px) 72.1%,
      calc(50% - 10px) 68.9%,
      calc(50% - 25px) 65.6%,
      calc(50% -  4px) 62.3%,
      calc(50% - 31px) 59.0%,
      calc(50% -  7px) 55.7%,
      calc(50% - 27px) 52.5%,
      calc(50% -  1px) 49.2%,
      calc(50% - 33px) 45.9%,
      calc(50% -  9px) 42.6%,
      calc(50% - 24px) 39.3%,
      calc(50% -  3px) 36.0%,
      calc(50% - 30px) 32.8%,
      calc(50% -  6px) 29.5%,
      calc(50% - 26px) 26.2%,
      calc(50% -  0px) 22.9%,
      calc(50% - 32px) 19.7%,
      calc(50% -  8px) 16.4%,
      calc(50% - 28px) 13.1%,
      calc(50% -  2px)  9.8%,
      calc(50% - 30px)  6.5%,
      calc(50% -  4px)  3.2%,
      calc(50% - 22px)  0%,
      100% 0%, 100% 100%
    );
  }

  /*
   * PHASE 1: tear to 30% — slow open, pause feel
   * PHASE 2: tear to 100% — smooth 3D peel-off-screen
   * We use two separate animation classes applied in sequence
   */

  /* Phase 1: open to ~30% and stop */
  .hlc-tear-left.tearing-phase1 {
    animation: hlc-tear-left-p1 0.9s cubic-bezier(0.25, 0.1, 0.25, 1) forwards;
  }
  .hlc-tear-right.tearing-phase1 {
    animation: hlc-tear-right-p1 0.9s cubic-bezier(0.25, 0.1, 0.25, 1) forwards;
  }

  @keyframes hlc-tear-left-p1 {
    0%   {
      transform: translateX(0) translateZ(0) rotateY(0deg) skewY(0deg);
      filter: drop-shadow(4px 0 12px rgba(180,0,200,0.5));
    }
    100% {
      transform: translateX(-30%) translateZ(40px) rotateY(-12deg) skewY(-1deg);
      filter: drop-shadow(10px 4px 28px rgba(180,0,200,0.7));
    }
  }
  @keyframes hlc-tear-right-p1 {
    0%   {
      transform: translateX(0) translateZ(0) rotateY(0deg) skewY(0deg);
      filter: drop-shadow(-4px 0 12px rgba(180,0,200,0.5));
    }
    100% {
      transform: translateX(30%) translateZ(40px) rotateY(12deg) skewY(1deg);
      filter: drop-shadow(-10px 4px 28px rgba(180,0,200,0.7));
    }
  }

  /* Phase 2: complete the tear — 3D page-off-screen effect */
  .hlc-tear-left.tearing-phase2 {
    animation: hlc-tear-left-p2 1.6s cubic-bezier(0.4, 0, 0.2, 1) forwards;
  }
  .hlc-tear-right.tearing-phase2 {
    animation: hlc-tear-right-p2 1.6s cubic-bezier(0.4, 0, 0.2, 1) forwards;
  }

  @keyframes hlc-tear-left-p2 {
    0%   {
      transform: translateX(-30%) translateZ(40px) rotateY(-12deg) skewY(-1deg);
      filter: drop-shadow(10px 4px 28px rgba(180,0,200,0.7));
    }
    30%  {
      transform: translateX(-55%) translateZ(120px) rotateY(-28deg) skewY(-3deg) scale(1.04);
      filter: drop-shadow(18px 8px 40px rgba(180,0,200,0.6));
    }
    70%  {
      transform: translateX(-90%) translateZ(220px) rotateY(-45deg) skewY(-5deg) scale(1.06);
      filter: drop-shadow(6px 2px 12px rgba(180,0,200,0.2));
    }
    100% {
      transform: translateX(-130%) translateZ(300px) rotateY(-55deg) skewY(-6deg) scale(1.08);
      filter: drop-shadow(0px 0px 0px rgba(0,0,0,0));
    }
  }
  @keyframes hlc-tear-right-p2 {
    0%   {
      transform: translateX(30%) translateZ(40px) rotateY(12deg) skewY(1deg);
      filter: drop-shadow(-10px 4px 28px rgba(180,0,200,0.7));
    }
    30%  {
      transform: translateX(55%) translateZ(120px) rotateY(28deg) skewY(3deg) scale(1.04);
      filter: drop-shadow(-18px 8px 40px rgba(180,0,200,0.6));
    }
    70%  {
      transform: translateX(90%) translateZ(220px) rotateY(45deg) skewY(5deg) scale(1.06);
      filter: drop-shadow(-6px 2px 12px rgba(180,0,200,0.2));
    }
    100% {
      transform: translateX(130%) translateZ(300px) rotateY(55deg) skewY(6deg) scale(1.08);
      filter: drop-shadow(0px 0px 0px rgba(0,0,0,0));
    }
  }

  /* ── inner panel ── */
  .hlc-tear-inner {
    position: absolute; inset: 0;
    background: radial-gradient(ellipse at 50% 42%, #160020 0%, #050008 72%);
    display: flex;
    align-items: center; justify-content: center;
    overflow: hidden;
  }

  /* ── stars ── */
  .hlc-stars { position: absolute; inset: 0; pointer-events: none; }
  .hlc-star {
    position: absolute; border-radius: 50%;
    animation: hlc-twinkle var(--dur) ease-in-out infinite alternate;
    opacity: var(--op);
  }
  @keyframes hlc-twinkle {
    from { opacity: var(--op); transform: scale(1); }
    to   { opacity: calc(var(--op)*0.1); transform: scale(0.3); }
  }

  /* ── color wash ripple ── */
  .hlc-ripple {
    position: absolute; border-radius: 50%; pointer-events: none; z-index: 2;
    left: 50%; top: 42%;
    transform: translate(-50%, -50%) scale(0);
    background: radial-gradient(circle, #ff00cc22 0%, #8800bb14 45%, transparent 70%);
  }
  .hlc-ripple.fire {
    animation: hlc-ripple-go 1.3s cubic-bezier(0.2, 1, 0.3, 1) forwards;
  }
  @keyframes hlc-ripple-go {
    0%   { transform: translate(-50%,-50%) scale(0);  opacity: 1; }
    65%  { opacity: 0.9; }
    100% { transform: translate(-50%,-50%) scale(7);  opacity: 0; }
  }

  /* ── ambient rings ── */
  .hlc-ring {
    position: absolute; border-radius: 50%;
    border: 1px solid #c0007a; pointer-events: none;
    animation: hlc-ring-p var(--rd, 3s) ease-in-out infinite;
    opacity: 0;
    left: 50%; top: 42%;
    transform: translate(-50%,-50%);
  }
  @keyframes hlc-ring-p {
    0%   { transform: translate(-50%,-50%) scale(0.5); opacity: 0; }
    50%  { opacity: 0.22; }
    100% { transform: translate(-50%,-50%) scale(2.4); opacity: 0; }
  }

  /* ── bulb stage ── */
  .hlc-bulb-stage {
    position: absolute; left: 50%; top: 42%;
    transform: translate(-50%, -50%); z-index: 10;
  }

  .hlc-bulb-drop {
    animation: hlc-drop 0.85s cubic-bezier(0.22, 1.6, 0.5, 1) forwards;
    opacity: 0;
  }
  @keyframes hlc-drop {
    from { transform: translateY(-130vh) rotate(-10deg); opacity: 0; }
    to   { transform: translateY(0) rotate(0deg);        opacity: 1; }
  }
  .hlc-bulb-sway { animation: hlc-sway 0.75s ease-in-out forwards; }
  @keyframes hlc-sway {
    0%  { transform: rotate(0); }  20% { transform: rotate(5deg); }
    55% { transform: rotate(-3deg); } 80% { transform: rotate(1.5deg); }
    100%{ transform: rotate(0); }
  }
  .hlc-bulb-shatter { animation: hlc-shat 0.45s cubic-bezier(0.55,0,1,0.45) forwards; }
  @keyframes hlc-shat {
    0%  { transform: scale(1);   opacity:1; filter:brightness(1); }
    25% { transform: scale(1.22); filter:brightness(8) saturate(0); }
    55% { transform: scale(0.8) rotate(7deg); opacity:0.4; }
    100%{ transform: scale(5) rotate(20deg); opacity:0; filter:brightness(3); }
  }

  /* ── halo ── */
  .hlc-halo {
    position: absolute; border-radius: 50%; pointer-events: none;
    background: radial-gradient(circle, #ff00cc55 0%, #9900cc18 50%, transparent 72%);
    left: 50%; top: 42%;
    transition: opacity 0.3s ease, transform 0.3s ease;
  }

  /* ── canvas layers ── */
  .hlc-rays-canvas, .hlc-spark-canvas {
    position: absolute; inset: 0; pointer-events: none;
  }
  .hlc-rays-canvas { z-index: 3; }
  .hlc-spark-canvas { z-index: 25; }

  /* ── light motes ── */
  .hlc-mote {
    position: absolute; border-radius: 50%; pointer-events: none; z-index: 8;
  }
  .hlc-mote.burst {
    animation: hlc-mote-go var(--md) cubic-bezier(0.2,1,0.3,1) forwards;
  }
  @keyframes hlc-mote-go {
    0%   { transform: translate(0,0) scale(1);                  opacity:1; }
    70%  { opacity: 0.7; }
    100% { transform: translate(var(--mx),var(--my)) scale(0.05); opacity:0; }
  }

  /* ── flash ── */
  .hlc-flash {
    position: absolute; inset: 0; background: #fff;
    pointer-events: none; z-index: 30;
    transition: opacity 0.12s ease;
  }

  /* ── home reveal ── */
  .hlc-home-reveal {
    position: fixed; inset: 0; z-index: 9998;
    transform: scale(0.92) translateY(8px); opacity: 0;
  }
  .hlc-home-reveal.bouncing {
    animation: hlc-bounce 0.82s cubic-bezier(0.34, 1.4, 0.64, 1) forwards;
  }
  @keyframes hlc-bounce {
    0%   { transform: scale(0.90) translateY(12px); opacity: 0.1; }
    50%  { transform: scale(1.028) translateY(-4px); opacity: 1; }
    72%  { transform: scale(0.982) translateY(2px); }
    88%  { transform: scale(1.010) translateY(-1px); }
    100% { transform: scale(1) translateY(0);        opacity: 1; }
  }
`;

// ─── Bulb SVG ─────────────────────────────────────────────────────────────────
function BulbSVG({ isOn, flicker }) {
  const filO  = isOn ? 1 : 0.28;
  const glwO  = isOn ? (flicker ? 0.3 : 1) : 0;
  const strk  = isOn ? "#ff88ff" : "#280636";
  const filC  = isOn ? "#ffccff" : "#6a4070";
  return (
    <svg width="180" height="240" viewBox="0 0 200 260" style={{ overflow:"visible", filter: isOn ? "drop-shadow(0 0 32px #ff00cc88)" : "none", transition:"filter 0.3s ease" }}>
      <defs>
        <radialGradient id="s_gOn" cx="38%" cy="30%" r="65%">
          <stop offset="0%"   stopColor="#fff0ff"/>
          <stop offset="28%"  stopColor="#ee44dd" stopOpacity=".82"/>
          <stop offset="100%" stopColor="#50005a" stopOpacity=".97"/>
        </radialGradient>
        <radialGradient id="s_gOff" cx="38%" cy="30%" r="65%">
          <stop offset="0%"   stopColor="#1e0e26"/>
          <stop offset="60%"  stopColor="#100515" stopOpacity=".97"/>
          <stop offset="100%" stopColor="#070010"/>
        </radialGradient>
        <radialGradient id="s_gCore" cx="50%" cy="50%" r="50%">
          <stop offset="0%"   stopColor="#ffffff"/>
          <stop offset="22%"  stopColor="#ffddff" stopOpacity=".9"/>
          <stop offset="100%" stopColor="#ff00cc" stopOpacity="0"/>
        </radialGradient>
        <radialGradient id="s_gShim" cx="28%" cy="25%" r="30%">
          <stop offset="0%"   stopColor="#ffffff" stopOpacity=".88"/>
          <stop offset="100%" stopColor="#ffffff" stopOpacity="0"/>
        </radialGradient>
        <filter id="s_fGlw">
          <feGaussianBlur in="SourceGraphic" stdDeviation="4" result="b"/>
          <feMerge><feMergeNode in="b"/><feMergeNode in="SourceGraphic"/></feMerge>
        </filter>
        <clipPath id="s_cB">
          <path d="M100 18 C58 18 26 55 26 98 C26 130 44 157 70 173 L70 200 C70 205 74 209 79 209 L121 209 C126 209 130 205 130 200 L130 173 C156 157 174 130 174 98 C174 55 142 18 100 18 Z"/>
        </clipPath>
      </defs>
      <ellipse cx="100" cy="102" rx="62" ry="62"
        fill="url(#s_gCore)" opacity={glwO} clipPath="url(#s_cB)"
        style={{ filter:"blur(10px)", transition:"opacity 0.25s ease" }}/>
      <path d="M100 18 C58 18 26 55 26 98 C26 130 44 157 70 173 L70 200 C70 205 74 209 79 209 L121 209 C126 209 130 205 130 200 L130 173 C156 157 174 130 174 98 C174 55 142 18 100 18 Z"
        fill={isOn ? "url(#s_gOn)" : "url(#s_gOff)"}
        stroke={strk} strokeWidth="1.5"
        style={{ transition:"fill 0.25s ease, stroke 0.25s ease" }}/>
      <g opacity={filO} style={{ transition:"opacity 0.25s ease" }}>
        <line x1="100" y1="158" x2="100" y2="140" stroke={filC} strokeWidth="1.5"/>
        <polyline points="100,140 84,124 114,108 84,92 114,76 100,64"
          fill="none" stroke={filC} strokeWidth="2.2"
          strokeLinecap="round" strokeLinejoin="round"
          filter={isOn ? "url(#s_fGlw)" : "none"}/>
        <line x1="100" y1="140" x2="100" y2="168" stroke={filC} strokeWidth="1.5"/>
        {[[84,124,78,154],[114,108,122,154],[84,92,78,154],[114,76,122,154]].map(([x1,y1,x2,y2],i)=>(
          <line key={i} x1={x1} y1={y1} x2={x2} y2={y2} stroke="#9040a0" strokeWidth="0.7" opacity="0.5"/>
        ))}
      </g>
      <ellipse cx="76" cy="60" rx="25" ry="17" fill="url(#s_gShim)" opacity="0.68"/>
      <rect x="72" y="208" width="56" height="11" rx="2" fill="#180422" stroke="#300a3c"/>
      <rect x="74" y="219" width="52" height="7"  rx="1" fill="#260832" stroke="#440c4e"/>
      <rect x="76" y="226" width="48" height="7"  rx="1" fill="#320744" stroke="#521260"/>
      <rect x="78" y="233" width="44" height="6"  rx="1" fill="#260036" stroke="#480b52"/>
      {[221,225,229,234,238].map((y,i)=>(
        <line key={i} x1={74+i} y1={y} x2={126-i} y2={y} stroke="#581468" strokeWidth="0.5" opacity="0.4"/>
      ))}
      <ellipse cx="100" cy="240" rx="20" ry="4.5" fill="#c0007a" opacity="0.9"/>
      <ellipse cx="100" cy="240" rx="20" ry="4.5" fill="none" stroke="#ff30aa" strokeWidth="0.8" opacity="0.5"/>
    </svg>
  );
}

// ─── Stars ────────────────────────────────────────────────────────────────────
function useParticles(n = 100) {
  return useRef(Array.from({ length: n }, () => ({
    x: Math.random() * 100,
    y: Math.random() * 100,
    r: Math.random() * 1.8 + 0.2,
    dur: (Math.random() * 3.5 + 1.5).toFixed(1),
    op: (Math.random() * 0.42 + 0.05).toFixed(2),
    color: ["#ffffff","#ffbbff","#cc44ff","#ff88cc","#aaddff"][Math.floor(Math.random()*5)],
  }))).current;
}

// ─── Animated Rays Canvas ─────────────────────────────────────────────────────
function RaysCanvas({ isOn, width, height }) {
  const ref    = useRef(null);
  const frame  = useRef(null);

  useEffect(() => {
    const canvas = ref.current;
    if (!canvas) return;
    canvas.width  = width;
    canvas.height = height;
    const ctx = canvas.getContext("2d");
    const cx  = width  / 2;
    const cy  = height * 0.42;

    const rays = Array.from({ length: 20 }, (_, i) => ({
      angle: (i / 20) * 360,
      len:   60 + Math.random() * 200,
    }));

    const draw = (ts) => {
      ctx.clearRect(0, 0, width, height);
      if (isOn) {
        const t = ts * 0.001;
        rays.forEach(({ angle, len }, i) => {
          const rad = (angle * Math.PI) / 180;
          const pulse = 0.5 + 0.5 * Math.sin(t * 2.2 + i * 0.38);
          const L  = len * (0.65 + 0.35 * pulse);
          const ex = cx + Math.cos(rad) * L;
          const ey = cy + Math.sin(rad) * L;
          const g  = ctx.createLinearGradient(cx, cy, ex, ey);
          g.addColorStop(0,   `rgba(255,50,220,${0.6 * pulse})`);
          g.addColorStop(0.5, `rgba(180,0,180,${0.28 * pulse})`);
          g.addColorStop(1,   "rgba(120,0,120,0)");
          ctx.beginPath();
          ctx.moveTo(cx, cy);
          ctx.lineTo(ex, ey);
          ctx.strokeStyle = g;
          ctx.lineWidth   = 2.5 * pulse;
          ctx.shadowBlur  = 14;
          ctx.shadowColor = "#ff00cc";
          ctx.stroke();
          ctx.shadowBlur  = 0;
        });
      }
      frame.current = requestAnimationFrame(draw);
    };

    frame.current = requestAnimationFrame(draw);
    return () => cancelAnimationFrame(frame.current);
  }, [isOn, width, height]);

  return (
    <canvas ref={ref} className="hlc-rays-canvas"
      style={{ width: "100%", height: "100%", position:"absolute", inset:0 }}/>
  );
}

// ─── Electric Spark Canvas ────────────────────────────────────────────────────
function SparkCanvas({ active, width, height }) {
  const ref   = useRef(null);
  const frame = useRef(null);

  useEffect(() => {
    const canvas = ref.current;
    if (!canvas) return;
    canvas.width  = width;
    canvas.height = height;
    const ctx = canvas.getContext("2d");

    if (!active) { ctx.clearRect(0, 0, width, height); return; }

    const cx = width / 2;
    let sparks = [];

    const newSpark = () => {
      const y      = Math.random() * height;
      const spread = 50 + Math.random() * 90;
      const pts    = Array.from({ length: 7 }, (_, i) => ({
        x: cx + (Math.random() - 0.5) * spread * (i / 6),
        y: y  + (Math.random() - 0.5) * 36,
      }));
      sparks.push({
        y, pts, life: 1,
        decay: 0.07 + Math.random() * 0.13,
        color: Math.random() > 0.4 ? "#ff88ff" : "#ffffff",
      });
    };

    for (let i = 0; i < 14; i++) newSpark();

    const draw = () => {
      ctx.clearRect(0, 0, width, height);
      sparks = sparks.filter(s => s.life > 0);
      if (sparks.length < 10) newSpark();

      sparks.forEach(s => {
        ctx.beginPath();
        ctx.moveTo(cx, s.y);
        s.pts.forEach(p => ctx.lineTo(p.x, p.y));
        ctx.strokeStyle  = s.color;
        ctx.lineWidth    = 1 + s.life * 1.5;
        ctx.globalAlpha  = s.life;
        ctx.shadowBlur   = 16;
        ctx.shadowColor  = "#ff00cc";
        ctx.stroke();
        ctx.globalAlpha  = 1;
        ctx.shadowBlur   = 0;
        s.life -= s.decay;
      });

      frame.current = requestAnimationFrame(draw);
    };

    frame.current = requestAnimationFrame(draw);
    return () => cancelAnimationFrame(frame.current);
  }, [active, width, height]);

  return (
    <canvas ref={ref} className="hlc-spark-canvas"
      style={{ width: "100%", height: "100%", position:"absolute", inset:0 }}/>
  );
}

// ─── Light Motes ─────────────────────────────────────────────────────────────
function LightMotes({ burst }) {
  const motes = useRef(Array.from({ length: 32 }, (_, i) => {
    const angle = (i / 32) * Math.PI * 2 + (Math.random() - 0.5) * 0.5;
    const dist  = 70 + Math.random() * 240;
    return {
      x: Math.cos(angle) * dist,
      y: Math.sin(angle) * dist,
      r: 2.5 + Math.random() * 7,
      dur: (0.5 + Math.random() * 1.1).toFixed(2),
      delay: (i * 0.009).toFixed(3),
      color: ["#ff80ff","#ffffff","#ff44cc","#cc00ff","#ffbbff","#ffff80"][Math.floor(Math.random()*6)],
    };
  })).current;

  if (!burst) return null;

  return (
    <>
      {motes.map((m, i) => (
        <div key={i} className="hlc-mote burst" style={{
          width:  m.r * 2, height: m.r * 2,
          background: `radial-gradient(circle, ${m.color}, transparent)`,
          boxShadow:  `0 0 ${m.r * 3}px ${m.color}`,
          left: "50%", top: "42%",
          marginLeft: -m.r, marginTop: -m.r,
          "--mx": `${m.x}px`, "--my": `${m.y}px`,
          "--md": `${m.dur}s`,
          animationDelay: `${m.delay}s`,
        }}/>
      ))}
    </>
  );
}

// ─── Inner panel content ──────────────────────────────────────────────────────
function SplashInner({ particles, isOn, flicker, phase, haloOp, haloScale, flashOp, moteBurst, w, h }) {
  return (
    <div className="hlc-tear-inner">
      <div className="hlc-stars">
        {particles.map((p, i) => (
          <div key={i} className="hlc-star" style={{
            left: `${p.x}%`, top: `${p.y}%`,
            width: p.r * 2, height: p.r * 2,
            background: p.color,
            "--dur": `${p.dur}s`, "--op": p.op,
            animationDelay: `${(i * 0.07) % 3}s`,
          }}/>
        ))}
      </div>

      {[140, 240, 360, 500].map((size, i) => (
        <div key={i} className="hlc-ring" style={{
          width: size, height: size,
          opacity: isOn ? undefined : 0,
          "--rd": `${2.6 + i * 0.7}s`,
          animationDelay: `${i * 0.65}s`,
        }}/>
      ))}

      <div className={`hlc-ripple${isOn ? " fire" : ""}`}
        style={{ width: 350, height: 350 }}/>

      <RaysCanvas isOn={isOn} width={w} height={h}/>

      <div className="hlc-halo" style={{
        width: 300, height: 300,
        opacity: haloOp,
        transform: `translate(-50%, -50%) scale(${haloScale})`,
      }}/>

      <LightMotes burst={moteBurst}/>

      <div className="hlc-flash" style={{ opacity: flashOp }}/>

      <div className="hlc-bulb-stage">
        <div className={
          phase === "drop"    ? "hlc-bulb-drop"    :
          phase === "sway"    ? "hlc-bulb-sway"    :
          phase === "shatter" ? "hlc-bulb-shatter" : ""
        }>
          <BulbSVG isOn={isOn} flicker={flicker}/>
        </div>
      </div>
    </div>
  );
}

// ─── Main export ──────────────────────────────────────────────────────────────
export default function HLCSplashScreen({ children, onComplete }) {
  const [phase,        setPhase]        = useState("drop");
  const [isOn,         setIsOn]         = useState(false);
  const [flicker,      setFlicker]      = useState(false);
  const [haloScale,    setHaloScale]    = useState(0.2);
  const [haloOp,       setHaloOp]       = useState(0);
  const [flashOp,      setFlashOp]      = useState(0);
  const [moteBurst,    setMoteBurst]    = useState(false);
  const [sparkActive,  setSparkActive]  = useState(false);
  // Two-phase tearing state
  const [tearPhase,    setTearPhase]    = useState(null); // null | "phase1" | "phase2"
  const [bouncing,     setBouncing]     = useState(false);
  const [done,         setDone]         = useState(false);
  const [dim,          setDim]          = useState({ w: window.innerWidth, h: window.innerHeight });

  const particles = useParticles(100);

  useEffect(() => {
    const onResize = () => setDim({ w: window.innerWidth, h: window.innerHeight });
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  useEffect(() => {
    const ids = [];
    const t = (fn, ms) => { const id = setTimeout(fn, ms); ids.push(id); };

    // ── Bulb drop → sway → idle
    t(() => setPhase("sway"), 850);
    t(() => setPhase("idle"), 1550);

    // ── Smooth single turn-on (no blink) with gentle fade-in
    t(() => {
      setIsOn(true);
      setFlicker(false);
      setHaloOp(0.6);
      setHaloScale(1.5);
    }, 2100);

    // ── Halo fully blooms
    t(() => {
      setHaloOp(1);
      setHaloScale(2.8);
      setMoteBurst(true);
    }, 2500);

    // ── Single clean flash
    t(() => {
      setFlashOp(0.7);
    }, 2560);
    t(() => {
      setFlashOp(0);
    }, 2680);

    // ── Pre-shatter double-flash (smooth, not jarring)
    t(() => { setFlashOp(0.45); }, 3100);
    t(() => { setFlashOp(0);    }, 3200);
    t(() => { setFlashOp(0.65); }, 3280);
    t(() => { setFlashOp(0);    }, 3400);

    // ── Shatter
    t(() => {
      setPhase("shatter");
      setIsOn(false);
      setHaloOp(0);
    }, 3450);

    // ── Sparks at seam
    t(() => { setSparkActive(true); }, 3600);

    // ── PHASE 1: tear opens to 30%
    t(() => {
      setTearPhase("phase1");
    }, 3750);

    // ── Pause at 30% — home page starts revealing behind
    t(() => { setBouncing(true); }, 4700);

    // ── PHASE 2: after 1 second pause, full 3D tear-off
    t(() => {
      setTearPhase("phase2");
      setSparkActive(false);
    }, 4750);

    // ── All done — after phase2 animation completes (1.6s)
    t(() => {
      setDone(true);
      if (onComplete) onComplete();
    }, 6500);

    return () => ids.forEach(clearTimeout);
  }, []);

  const tearClass = (side) => {
    const base = side === "left" ? "hlc-tear-left" : "hlc-tear-right";
    if (tearPhase === "phase1") return `${base} tearing-phase1`;
    if (tearPhase === "phase2") return `${base} tearing-phase2`;
    return base;
  };

  const sp = { particles, isOn, flicker, phase, haloOp, haloScale, flashOp, moteBurst, w: dim.w, h: dim.h };

  return (
    <>
      <style>{CSS}</style>

      {/* Home page revealed behind the tearing panels */}
      {!done && (
        <div className={`hlc-home-reveal${bouncing ? " bouncing" : ""}`}>
          {children}
        </div>
      )}

      {/* Normal render after done */}
      {done && children}

      {/* Splash overlay */}
      {!done && (
        <div className="hlc-splash-overlay">
          <div className={tearClass("left")}>
            <SplashInner {...sp}/>
          </div>
          <div className={tearClass("right")}>
            <SplashInner {...sp}/>
          </div>
          <SparkCanvas active={sparkActive} width={dim.w} height={dim.h}/>
        </div>
      )}
    </>
  );
}